import './breadcrumb.scss'

export default function breadcrumb($stateParams, $state) {
  'ngInject'
  var directive = {
    restrict: 'E',
    scope: {
      url: '@',
    },
    templateUrl: 'app/components/breadcrumb/breadcrumb.html',
    link: breadLink,
  }

  return directive

  function breadLink($scope, $element, $attr) {
    $scope.urls = []

    var urls = $attr.url.split('/')
    for (var i = 0; i < urls.length; i++) {
      if (urls.length - 1 === i) {
        $scope.urls.push({
          active: true,
          name: urls[i].capitalizeFirstLetter(),
        })
      } else {
        $scope.urls.push({
          active: false,
          name: urls[i].capitalizeFirstLetter(),
        })
      }
    }

    $scope.link = function (item) {
      var id = localStorage.getItem('channelId')
      switch (item.name) {
        case 'Channels':
          $state.go('pub.channels')
          break
        case 'Sets':
          $state.go('pub.channels.sets', { parentId: id })
          break
        case 'Collectibles':
          $state.go('pub.collectibles', {
            parentId: $stateParams.parentId,
          })
          break
        case 'Shinies':
          $state.go('pub.collectibles.shinies', {
            parentId: $stateParams.parentId,
            collectibleId: $stateParams.collectibleId,
          })
          break
        case 'Bundles':
          if (window.location.search.indexOf('channelId') > -1) {
            $state.go('pub.bundles', {
              parentId: $stateParams.parentId,
              channelId: id,
            })
          } else {
            $state.go('pub.bundles', {
              parentId: $stateParams.parentId,
            })
          }
          break
        case 'Reviews':
          $state.go('pub.reviews', { parentId: $stateParams.parentId })
          break
        case 'Drops':
          $state.go('pub.drops')
          break
        case 'Top prizes':
          $state.go('pub.channels.top_prizes', { parentId: id })
          break
        default:
          $state.go('pub.channels')
          break
      }
    }
  }
}
